'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSoa } from '../../Entities/User/UserSoa';
import { UserSoaCollection } from '../../Collections/User/UserSoaCollection';

export class UserSoaRepository extends CoreRepository {
  public getIndSoas(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndSoas(indId, options).then((response) => {
      const collection = new UserSoaCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSoa();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getIndSoa(indId: number, uuid: string, options: object = null) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getIndSoa(indId, uuid, options).then((response) => {
      if (!response) {
        return false;
      }

      const userSoa = new UserSoa();
      userSoa.hydrate(response);

      return userSoa;
    });
  }

  public createIndSoa(indId: number, payload: any[]) {
    return this.webAPI.createIndSoa(indId, payload).then((response) => {
      const userSoa = new UserSoa();
      userSoa.hydrate(response);

      return userSoa;
    });
  }

  public removeIndSoa(indId: number, soaId: number) {
    return this.webAPI.removeIndSoa(indId, soaId).then((response) => {
      return response;
    });
  }

  public updateIndSoa(indId: number, soaId: number, payload: any[]) {
    return this.webAPI.updateIndSoa(indId, soaId, payload).then((response) => {
      const userSoa = new UserSoa();
      userSoa.hydrate(response);

      return userSoa;
    });
  }

  public updateIndSoaCode(indId: number, soaId: number, payload: any[]) {
    return this.webAPI.updateIndSoaCode(indId, soaId, payload).then((response) => {
      const userSoa = new UserSoa();
      userSoa.hydrate(response);

      return userSoa;
    });
  }

  public moveUserSoa(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveUserSoa(userId, individualId, payload).then((response) => {
      return response;
    });
  }
}
